// Admin plan/tier management (feature entitlement) - staff only.
// Distinct from billing (staff_set_billing): this sets which FEATURES a tenant gets.
import { supabase } from '@govern360/shared';

export async function staffGetTenantPlan(orgId) {
  const { data, error } = await supabase.rpc('staff_get_tenant_plan', { p_org_id: orgId });
  return { data, error };
}
export async function staffSetTenantPlan(orgId, tierKey, seats, status) {
  const { data, error } = await supabase.rpc('staff_set_tenant_plan', {
    p_org_id: orgId, p_tier_key: tierKey,
    p_seats: seats === '' || seats == null ? null : Number(seats),
    p_status: status || 'active',
  });
  return { data, error };
}
export async function staffClearTenantPlan(orgId) {
  const { data, error } = await supabase.rpc('staff_clear_tenant_plan', { p_org_id: orgId });
  return { data, error };
}